import { toAbsoluteUrl } from "../../_metronic/helpers";


export const merchantPicture = pictureUrl => pictureUrl ?? toAbsoluteUrl('/media/stock/900x600/1.jpg')
export const courseThumbnail = thumbnailUrl => thumbnailUrl ?? toAbsoluteUrl('/media/stock/900x600/1.jpg')
export const userProfilePicture = profilePictureUrl => profilePictureUrl ?? toAbsoluteUrl('/media/avatars/300-1.jpg')